import { RootState } from '@app/redux/root-reducer';

const slice = (state: RootState) => state.favoriteReducer;

export const getFavoriteItems = (state: RootState) => slice(state).favoriteItems;

export const selectIsHasInFavorite = (state: RootState, id: string) =>
  slice(state).favoriteItems?.data?.some((e: any) => e.uri == id);
